export default __webpack_public_path__ + "static/media/upcoming_30_black.0ce2af16.svg";